export default __webpack_public_path__ + "static/media/Forms.d43c0afd.svg";